import { Badge, Button, Card, Col, Container, ListGroup, Row } from "react-bootstrap";
import { getLocalizedDate } from "../../shared/helpers/localizationHelper";
import { useNavigate } from "react-router-dom";


const InvoiceListView = ({ orderData }) => {
    const navigate = useNavigate();
    const handleRowClick = (data) => {
        navigate("/plan/default/" + data?.id);
    };
    return (
        <>
            <Card>
                <Card.Body className="px-0 py-0">
                    <Row className="g-0">
                        <Col lg={6}>
                            {orderData && orderData?.length > 0 && orderData.map((value) => {
                                console.log("value", value)
                                const isoDateString = value.created_at;
                                return (
                                    <ListGroup onClick={() => handleRowClick(value)}>
                                        <ListGroup.Item className="cursor-pointer" >
                                            <div className="d-flex justify-content-between">
                                                <div className="d-flex flex-column">
                                                    {/* <span className="bold">Order Id</span> */}
                                                    <span># {value?.order_number}</span>
                                                </div>
                                                <div className="d-flex flex-column">
                                                    {/* <span className="bold">Txn Date</span> */}
                                                    <span>{getLocalizedDate(isoDateString)}</span>
                                                </div>
                                            </div>
                                            <div className="d-flex justify-content-between mt-3">
                                                <div className="d-flex flex-column">
                                                    <span className="bold" style={{ color: 'gray' }}>Total</span>
                                                    <span>₹ {value?.grand_total}</span>
                                                </div>
                                                <div className="d-flex flex-column">
                                                    <span className="bold " style={{ color: 'gray' }}>Paid</span>
                                                    <span>₹ {value?.paid_amount}</span>
                                                </div>
                                                <div className="d-flex flex-column">
                                                    <span className="bold" style={{ color: 'gray' }}>Status</span>
                                                    <Badge
                                                        bg={
                                                            value.status === "paid"
                                                                ? "success"
                                                                : value.status === "Partially Paid"
                                                                    ? "warning"
                                                                    : "danger"
                                                        }
                                                        className="px-3 py-2 rounded"
                                                        style={{
                                                            color:
                                                                value.status === "paid"
                                                                    ? "white"
                                                                    : value.status === "Partially Paid"
                                                                        ? "black"
                                                                        : "white",
                                                        }}
                                                    >
                                                        {value?.status}
                                                    </Badge>
                                                </div>
                                            </div>
                                        </ListGroup.Item>
                                    </ListGroup>

                                );
                            })}
                        </Col>
                    </Row>

                </Card.Body>
            </Card>
        </>
    )
}

export default InvoiceListView;